import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
const AnnouncementSwiper = {

    swiper: null,

    init() {
        if ($('.jsAnnouncement').length > 0) {
            this.initSlider();
            this.initEvents();
        }
    },
    initSlider() {
        this.swiper = new Swiper($('.jsAnnouncement')[0], {
            loop: true,
            effect: 'fade',
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            allowTouchMove: false,
            // autoplay:true,
            speed: 500,

            modules: [Navigation, Pagination, Autoplay, EffectFade],
        });
    },
    initEvents() {
        const self = this;
        $('.page-topbar').on('click', '.headline', function(e) {
            e.preventDefault();
            const $headline = $(this);
            const $slide = $headline.closest('.swiper-slide');
            const slideIndex = $slide.data('swiper-slide-index');
            const $allRelatedSlides = $headline.closest('.swiper-container').find(`.swiper-slide[data-swiper-slide-index="${slideIndex}"]`);
            
            const $collapses = $allRelatedSlides.find('.headline__collapse');
            const $headlines = $allRelatedSlides.find('.headline');

            const isShown = $collapses.hasClass('show');

            if (isShown) {
                $collapses.removeClass('show');
                $headlines.addClass('collapsed');
                $headlines.attr('aria-expanded', 'false');
                if (self.swiper && self.swiper.autoplay) {
                    self.swiper.autoplay.start();
                }
            } else {
                $collapses.addClass('show');
                $headlines.removeClass('collapsed');
                $headlines.attr('aria-expanded', 'true');
                if (self.swiper && self.swiper.autoplay) {
                    self.swiper.autoplay.stop();
                }
            }
        });
    },

}
export default AnnouncementSwiper;


// WEBPACK FOOTER //
// ./scripts/modules/announcement-swiper.js